import React, { useEffect, useRef, useState } from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CFormSelect,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "src/components/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { getAllCompany } from "src/redux/actions/companyAction";
import ReactPaginate from "react-js-pagination";
import AddForm from "./detailForm";
import { getCollections } from "src/api/allApis";
import { useReactToPrint } from "react-to-print";
import Vakilkaro from "src/assets/brand/vakilkaro";
import {
  COMPANY_AddLogo,
  COMPANY_Address,
  COMPANY_NAME,
} from "src/services/const";

const LoanSummary = () => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state?.companyReducer);

  const [filteredItem, setFilteredItem] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showAccordion, setShowAccordion] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [companyModel, setCompanyModel] = useState(false);
  const [showAddButton, setShowAddButton] = useState(true);
  const [showSelectAndSearch, setShowSelectAndSearch] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  const [startDate, setStartDate] = useState("");
  const [printState, setPrintState] = useState(false);
  const [endDate, setEndDate] = useState("");
  const employeeId = sessionStorage.getItem("emplyeeId");
  const employeeRole = sessionStorage.getItem("role");

  //const rowsPerPage = 10;
  const [collections, setCollections] = useState([]);
  const componentPDF = useRef();

  const fetchCollection = async () => {
    const data = await getCollections({
      schemaName: sessionStorage.getItem("schemaName"),
    });
    setCollections(data?.data || []);
    setCompanyModel(true);
  };

  useEffect(() => {
    dispatch(getAllCompany());
    fetchCollection();
  }, []);

  useEffect(() => {
    if (printState) {
      generatePDF();
    }
  }, [printState]);

  useEffect(() => {
    if (employeeRole == "agent") {
      const filteredData = collections?.filter(
        (element) =>
          String(element?.customer?.employeeId) === String(employeeId) &&
          element?.emiStatus === "pending"
      );
      setFilteredItem(filteredData);
    } else {
      const filteredData = collections?.filter(
        (element) => element?.emiStatus === "pending"
      );
      setFilteredItem(filteredData);
    }
  }, [companyModel, employeeId]);

  useEffect(() => {
    if (startDate && endDate) {
      const filteredData = collections?.filter((element) => {
        const dueDate = new Date(element?.dueDate);
        const start = new Date(startDate);
        const end = new Date(endDate);
        return (
          dueDate >= start && dueDate <= end && element?.emiStatus === "pending"
        );
      });
      setFilteredItem(filteredData);
    } else {
      if (employeeRole === "agent") {
        const filteredData = collections?.filter(
          (element) =>
            String(element?.customer?.employeeId) === String(employeeId) &&
            element?.emiStatus === "pending"
        );
        setFilteredItem(filteredData);
      } else {
        const filteredData = collections?.filter(
          (element) => element?.emiStatus === "pending"
        );
        setFilteredItem(filteredData);
      }
    }
  }, [companyModel, employeeId, startDate, endDate]);

  const download_btn = () => {
    setPrintState(true);
  };
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredItem?.slice(indexOfFirstRow, indexOfLastRow);

  const handleShowAddForm = () => {
    // When the user clicks the "Add" button, hide the button and show the form
    setShowAddButton(false);
    setShowAddForm(true);
    setShowSelectAndSearch(false);
  };

  const handleViewForm = (company) => {
    setShowSelectAndSearch(false);
    setSelectedCompany(company);
    setShowAccordion(true);
  };

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  return (
    <>
      <CRow className="content">
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <strong>Pending Collections</strong>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol xs={12}>
                  <CCard>
                    <CCardBody>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Count */}
                        <div style={{ margin: "0px 0px -22px 0px" }}>
                          <CFormSelect
                            onChange={(e) => setRowsPerPage(e.target.value)}
                            size="sm"
                            className="mb-3"
                            style={{ cursor: "pointer" }}
                            aria-label="Small select example"
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                          </CFormSelect>
                        </div>
                        {/* )} */}

                        {/* Date */}
                        <div style={{ display: "flex" }}>
                          {showSelectAndSearch && (
                            <>
                              <CFormInput
                                type="date"
                                size="sm"
                                placeholder="Start Date"
                                aria-label="sm input example"
                                onChange={(e) => setStartDate(e.target.value)}
                                value={startDate}
                              />
                              <CFormInput
                                type="date"
                                size="sm"
                                placeholder="End Date"
                                aria-label="sm input example"
                                onChange={(e) => setEndDate(e.target.value)}
                                value={endDate}
                              />
                            </>
                          )}
                        </div>

                        <div style={{ display: "flex" }}>
                          {showSelectAndSearch && (
                            <>
                              <CFormInput
                                type="text"
                                size="sm"
                                placeholder="Select Agent"
                                aria-label="sm input example"
                                onChange={handleSearchChange}
                                value={searchInput}
                              />

                              <span
                                style={{
                                  border: " 1px solid #d1c5c5",
                                  borderRadius: "4px",
                                  margin: "0px 5px 0px -1px",
                                  padding: "1px 8px 0px 8px",
                                  background: "#ebedef",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fa fa-search"></i>
                              </span>
                            </>
                          )}
                        </div>

                        <div style={{ display: "flex" }}>
                          {showSelectAndSearch && (
                            <>
                              <CFormInput
                                type="text"
                                size="sm"
                                placeholder="Search"
                                aria-label="sm input example"
                                onChange={handleSearchChange}
                                value={searchInput}
                              />

                              <span
                                style={{
                                  border: " 1px solid #d1c5c5",
                                  borderRadius: "4px",
                                  margin: "0px 5px 0px -1px",
                                  padding: "1px 8px 0px 8px",
                                  background: "#ebedef",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fa fa-search"></i>
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </CCardBody>
                    <CCardBody>
                      {/* code search_bar */}
                      <div className="mb-4">
                        <div className="search_bar">
                          {/* div 1 started */}
                          <div className="search-inner">
                            {/* {showSelectAndSearch && ( */}
                            {/* <div>
                              <CFormSelect
                                size="sm"
                                className="mb-3"
                                style={{ cursor: "pointer" }}
                                aria-label="Small select example"
                                // onChange={(e) => setRowsPerPage(e.target.value)}
                              >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                              </CFormSelect>
                            </div> */}
                            {/* )} */}
                            {/* search div */}
                            {/* <div style={{ display: "flex" }}> */}
                            {/* {showSelectAndSearch && ( */}
                            {/* <>
                      <CFormInput
                        type="text"
                        size="sm"
                        placeholder="Search"
                        aria-label="sm input example"
                        style={{ margin: "0px 0px 16px 0px" }}
                        // onChange={handleSearchChange}
                        // value={searchInput}
                      />
                      <span
                        style={{
                          border: " 1px solid #d1c5c5",
                          borderRadius: "4px",
                          margin: "0px 5px 16px -1px",
                          padding: "1px 8px 0px 8px",
                          background: "#ebedef",
                          cursor: "pointer",
                        }}
                      >
                        <i className="fa fa-search"></i>
                      </span>
                    </> */}
                            {/* )} */}
                            {/* </div> */}
                          </div>
                          {/* div 1 ended */}

                          {/* both btn div */}
                          <div className="btn_add mt-0 mb-14">
                            {/* <CButton
                              className="add-btn w-auto plr-30 mr-10 "
                              // onClick={handleShowAddForm}
                            >
                              Add
                            </CButton> */}

                            <CButton
                              className="add-btn m-0 w-auto"
                              onClick={download_btn}
                            >
                              Download
                            </CButton>
                          </div>
                        </div>
                      </div>
                      {/* search_bar end */}
                      <div
                        className={`table-container ${showAccordion ? "hidden" : ""
                          } ${showAddForm ? "hidden" : ""}`}
                      >
                        <div
                          ref={printState ? componentPDF : null}
                          style={{ padding: printState ? "20px" : "0px" }}
                        >
                          {printState && (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                background:
                                  "linear-gradient(180deg, #1e2639, #222b40, #4c5a7a, #7c90c2)",
                                padding: "20px",
                              }}
                            >
                              <img
                                src={COMPANY_AddLogo}
                                alt="Logo"
                                width="50px"
                                height="50px"
                              />
                              <p style={{ color: "#FFF" }}>Emi Details</p>
                              <div style={{ textAlign: "start" }}>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    color: "#FFF",
                                    fontSize: "20px",
                                  }}
                                >
                                  {COMPANY_NAME}
                                </p>
                                <p
                                  style={{ color: "#FFF" }}
                                >{`(${COMPANY_Address})`}</p>
                              </div>
                            </div>
                          )}
                          <CTable color="dark" hover className="" responsive>
                            <CTableHead>
                              <CTableRow>
                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-1"
                                >
                                  S. No.
                                </CTableHeaderCell>

                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-2"
                                >
                                  Member Name
                                </CTableHeaderCell>

                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-1"
                                >
                                  Mobile
                                </CTableHeaderCell>
                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-2"
                                >
                                  Pay Date
                                </CTableHeaderCell>
                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-1"
                                >
                                  Duration
                                </CTableHeaderCell>
                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-1"
                                >
                                  Amount
                                </CTableHeaderCell>
                                <CTableHeaderCell
                                  scope="col"
                                  className="col-md-1"
                                >
                                  Status
                                </CTableHeaderCell>
                                {!printState && (
                                  <CTableHeaderCell
                                    scope="col"
                                    className="col-md-2"
                                  >
                                    Action
                                  </CTableHeaderCell>
                                )}
                              </CTableRow>
                            </CTableHead>
                            <CTableBody>
                              {currentRows
                                ?.filter((item) =>
                                  item?.customer?.firstName
                                    .toLowerCase()
                                    .includes(searchInput.toLowerCase())
                                )
                                ?.map((company, index) => (
                                  <CTableRow key={index}>
                                    <CTableDataCell>{index + 1}</CTableDataCell>
                                    <CTableDataCell>
                                      {company?.customer?.firstName}{" "}
                                      {company?.customer?.middleName ==
                                        "undefined"
                                        ? ""
                                        : company?.customer?.middleName}{" "}
                                      {company?.customer?.lastName}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {company?.customer?.phoneNumber}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {/* {company?.customer?.bankName} */}
                                      Anjani Creations
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {company?.dueDate}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {company?.loadDurationInMonths}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {company?.loadAmount}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      <span className="pending_status">
                                        <span
                                          className={
                                            company?.emiStatus == "pending"
                                              ? "pending"
                                              : company?.emiStatus == "success"
                                                ? "success"
                                                : "reject"
                                          }
                                        // onClick={() => alert("Hello")}
                                        >
                                          {company?.emiStatus?.toUpperCase()}
                                        </span>
                                      </span>
                                    </CTableDataCell>
                                    {!printState && (
                                      <CTableDataCell className="col-md-2">
                                        <Tooltip text="View">
                                          <FontAwesomeIcon
                                            role="button"
                                            icon={faEye}
                                            size="1x"
                                            className="viewIcon"
                                            onClick={() => handleViewForm()}
                                          />
                                        </Tooltip>

                                        <Tooltip text="Update">
                                          <FontAwesomeIcon
                                            role="button"
                                            icon={faPenToSquare}
                                            size="1x"
                                            onClick={() => handleShowAddForm()}
                                            className="px-3 updateIcon"
                                          />
                                        </Tooltip>
                                      </CTableDataCell>
                                    )}
                                  </CTableRow>
                                ))}
                            </CTableBody>
                          </CTable>
                        </div>

                        <div className="pagin-div">
                          <div>
                            Showing {indexOfFirstRow + 1} to{" "}
                            {Math?.min(indexOfLastRow, filteredItem?.length)} of{" "}
                            {filteredItem?.length} entries
                          </div>
                          <div className="pagination-container">
                            <ReactPaginate
                              activePage={currentPage}
                              itemsCountPerPage={rowsPerPage}
                              totalItemsCount={filteredItem?.length}
                              pageRangeDisplayed={5}
                              onChange={handlePageChange}
                              prevPageText="Previous"
                              nextPageText="Next"
                              firstPageText="First"
                              lastPageText="Last"
                              innerClass="pagination"
                              itemClass="page-item"
                              linkClass="page-link"
                            />
                          </div>
                        </div>
                      </div>
                      {/* {showAccordion && (
                <ViewDetails
                  selectedCompany={selectedCompany}
                  setShowAccordion={setShowAccordion}
                  setShowSelectAndSearch={setShowSelectAndSearch}
                />
              )} */}
                      {showAddForm && (
                        <AddForm
                          selectedCompany={selectedCompany}
                          setShowAddForm={setShowAddForm}
                          setShowAddButton={setShowAddButton}
                          setShowSelectAndSearch={setShowSelectAndSearch}
                        />
                      )}
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs={12}>
          <div
            className={`accordion-container ${showAccordion ? "visible" : ""}`}
          ></div>
        </CCol>
      </CRow>
    </>
  );
};

export default LoanSummary;
